import { selectors } from 'data'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import EligibilityModal from './EligibilityModal'

const EligibilityNotifications = () => {
  const eligibility = useSelector(selectors.eligibility.getEligibility)
  const user = useSelector(selectors.auth.getUser)
  const [dismissed, setDismissed] = useState(false)

  if (!user?.address || dismissed) return null

  if (eligibility.notifications && eligibility.notifications[0]?.reason === 'EU_5_SANCTION') {
    return <EligibilityModal onDone={() => setDismissed(true)} />
  }

  return null
}

export default EligibilityNotifications
